/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  document.addEventListener('theme:variant:change', function(event) {
    // You might use something like this to write a pre-order feature or a
    // custom swatch feature.
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
      // ... update some element on the page
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    // BXZ code
    setTimeout(function() {
      if (GetCurrency) GetCurrency();
    }, 500);
    // BXZ code
    
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      if (cart.item_count == 0) {
        document.querySelector('.section-related-below-images-wrapper').classList.add('hide');
        document.querySelector('.drawer__body').classList.remove('cart-full');
      }
      else {
        document.querySelector('.section-related-below-images-wrapper').classList.remove('hide');
        document.querySelector('.drawer__body').classList.add('cart-full');
      }
      if (cart.item_count > 1) {
        document.querySelector('.cart__items').classList.add('multiple-cart-items');
      } else {
        document.querySelector('.cart__items').classList.remove('multiple-cart-items');
      }
      // ... update an app or a custom shipping caluclator
    }
  });

  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });
  document.addEventListener('theme:cart:reload', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  window.addEventListener('load', (event) => {
    if (window.innerWidth < 480 && document.querySelector('body').classList.contains('template-product')) {
      let related_products_desktop_section = document.querySelector(".related-products-wrapper").innerHTML;
      let related_products_mobile_location = document.querySelector(".limespot-mobile").innerHTML;
      document.querySelector(".limespot-mobile").innerHTML = related_products_desktop_section;
      document.querySelector(".related-products-wrapper").innerHTML = '';
    }
  });

 enable_arrows();

  function enable_arrows() {
    let arrows_left = document.querySelectorAll('.product-media-arrows-left');
    arrows_left.forEach(function(item) {
      item.addEventListener('click', function(e) {
        e.preventDefault(); 
        let total_images = -1;
        //alert(this.getAttribute('data-left'));
        let left_spot = this.getAttribute('data-left');
        let left_spot_minus_one = left_spot - 2;
        let elem = this.closest('.product-grid-item__images').querySelectorAll(".product-grid-item__image");
        let new_active_image = elem[left_spot - 2];
        //alert(link2);
        //alert(elem);
        //alert(left_spot_minus_one);
        //alert(total_images);
        if(left_spot_minus_one > total_images) {
          elem[left_spot - 1].classList.remove('is-active');
          new_active_image.classList.add('is-active');
        }
      });
    });

    let arrows_right = document.querySelectorAll('.product-media-arrows-right');
    arrows_right.forEach(function(item) {
      item.addEventListener('click', function(e) {
        e.preventDefault(); 
        let total_images = this.closest('.product-grid-item__images').getAttribute('data-grid-images');
        //alert(this.getAttribute('data-right'));
        let right_spot = this.getAttribute('data-right');
        let right_spot_minus_one = right_spot - 1;
        let elem = this.closest('.product-grid-item__images').querySelectorAll(".product-grid-item__image");
        let new_active_image = elem[right_spot - 1];
        //alert(link2);
        //alert(elem);
        //alert(right_spot_minus_one);
        //alert(total_images);
        if(right_spot_minus_one < total_images) {
          elem[right_spot - 2].classList.remove('is-active');
          new_active_image.classList.add('is-active');
        }
      });
    });

    let images_hover = document.querySelectorAll('.product-grid-item__images');
    images_hover.forEach((item) => {
      item.addEventListener('mouseenter', function () {
        let elem = this.querySelectorAll(".product-grid-item__image");
        elem[0].classList.remove('is-active');
        elem[1].classList.add('is-active');
        }
      );
    });
    images_hover.forEach((item) => {
      item.addEventListener('mouseleave', function () {
        let elem = this.querySelectorAll(".product-grid-item__image");
        elem[1].classList.remove('is-active');
        elem[0].classList.add('is-active');
        }
      );
    });
  }
  
})();
